export const QNAS = {
  en: [
    { 
      question: 'Why is plastic surgery famous in Korea?',
      answer: 'Korean plastic surgery is known for natural results thanks to cutting-edge techniques and skilled specialists. Detailed pre-surgery consultations and personalized planning lead to high satisfaction rates. The influence of K-beauty trends and the Korean Wave has made it trusted by patients worldwide.'
    },
    { 
      question: 'Do many foreign patients visit Korean plastic surgery clinics?',
      answer: 'Yes, Korean plastic surgery clinics are popular among foreign patients. Various language services including English, Chinese, and Japanese, along with medical interpreters, are available for your comfort. Specialized coordinators for international patients make consultations and surgeries convenient.'
    },
    { 
      question: 'What should I prepare and be cautious about before and after plastic surgery?',
      answer: 'Before surgery, check your health condition and thoroughly discuss expected results with your doctor. After surgery, avoid smoking and drinking, take prescribed medications, and get plenty of rest. It is also important to keep the surgical site clean and avoid strenuous exercise or activities.'
    },
    { 
      question: 'Is anesthesia safe when getting plastic surgery in Korea?',
      answer: 'Korean plastic surgery clinics have professional anesthesiologists who safely manage the anesthesia process. Pre-surgery anesthesia consultations check your health status, so you can feel reassured. Necessary equipment and procedures are prepared for any potential emergency situations, ensuring safe procedures.'
    },
    { 
      question: 'Do Korean plastic surgeons reflect the latest trends well?',
      answer: 'Yes, Korean doctors actively incorporate the latest beauty trends, including K-beauty. They study diverse beauty preferences from around the world, understanding various styles. With thorough discussions with your doctor, you can adjust the approach to match your desired image.'
    },
    { 
      question: 'How are plastic surgery side effects or complications prevented?',
      answer: 'Thorough pre-surgery examinations and detailed diagnoses minimize the possibility of side effects. During surgery, sterile management and skilled techniques prevent complications. Regular post-surgery monitoring and care help detect and address any potential issues early.'
    },
    { 
      question: 'How much does plastic surgery cost in Korea?',
      answer: 'Costs vary depending on the type and complexity of the surgery, but Korean plastic surgery costs are generally considered reasonable. Since many procedures are performed at private specialized clinics rather than public hospitals, average costs can vary widely. For accurate pricing, it is best to get a quote during consultation based on your individual condition and desired scope of procedures.'
    },
    { 
      question: 'Which plastic surgeries are most popular in Korea?',
      answer: 'Face-centered surgeries like double eyelid surgery, rhinoplasty, and facial contouring are especially popular. Procedures like lifting for skin elasticity and Botox are also common. Since everyone wants to improve different areas, it is recommended to consult with a specialist to choose the surgery that is right for you.'
    },
    { 
      question: 'How long is the recovery period after plastic surgery?',
      answer: 'Recovery times vary by procedure, but generally daily activities become possible after 1-2 weeks. Swelling and bruising typically improve over 2-3 weeks, with complete recovery taking about 3-6 months. Individual differences exist, so it is best to plan your recovery schedule according to your doctor instructions.'
    },
    { 
      question: 'What should I do if I am not satisfied with my plastic surgery results?',
      answer: 'First, allow sufficient recovery time before judging the results. If you are still not satisfied, have an honest discussion with your doctor. Corrective procedures or revision surgeries may be considered if necessary, and it is important to follow your specialist advice in these cases.'
    },
  ],
  ko: [
    { 
      question: '한국에서 성형수술이 유명한 이유가 무엇인가요?',
      answer: '한국 성형수술은 최신 기술과 숙련된 전문의 덕분에 자연스러운 결과로 유명해요. 수술 전 상세한 상담과 개인 맞춤 계획으로 만족도가 높아요. K-뷰티 트렌드와 한류 영향으로 전 세계 환자들이 신뢰하며 찾고 있죠.'
    },
    { 
      question: '한국 성형외과는 외국인 환자도 많이 방문하나요?',
      answer: '네, 한국 성형외과는 외국인 환자들에게 인기 있어요. 영어, 중국어, 일본어 등 다양한 언어 서비스와 의료 통역사가 지원되니 안심하세요. 해외 환자를 위한 전문 코디네이터도 있어서 편리하게 상담과 수술을 받을 수 있어요.'
    },
    { 
      question: '성형수술 전 후에 어떤 점을 준비하고 주의해야 하나요?',
      answer: '수술 전에는 건강상태를 체크하고 의사와 기대 결과를 충분히 상의해야 해요. 수술 후에는 금연, 금주와 함께 처방받은 약을 잘 복용하고 안정이 필요해요. 또한, 수술 부위를 깨끗이 관리하고 무리한 운동이나 활동은 피하는 것이 좋아요.'
    },
    { 
      question: '한국에서 성형수술할 때 마취는 안전한가요?',
      answer: '한국 성형외과는 전문 마취과 의사가 있어서 마취 과정이 안전하게 관리돼요. 수술 전 마취 관련 상담을 통해 건강 상태를 체크하니 안심하셔도 돼요. 혹시 모를 응급 상황도 대비해 필요한 장비와 절차가 준비되어 있어 안전하게 진행돼요.'
    },
    { 
      question: '한국 성형외과 의사들은 최신 트렌드를 잘 반영하나요?',
      answer: '네, 한국 의사들은 K-뷰티를 비롯한 최신 미용 트렌드를 적극 반영해요. 전 세계에서 들어오는 다양한 미용 선호도를 연구하고 있어서 여러 스타일을 이해하고 있어요. 의사와 충분히 의논하면 원하는 이미지에 맞춰 조율할 수 있어요.'
    },
    { 
      question: '성형수술 부작용이나 합병증은 어떻게 예방하나요?',
      answer: '수술 전 정밀 검사와 꼼꼼한 진단으로 부작용 가능성을 최대한 줄여요. 수술 중 무균 관리와 숙련된 의사의 기술로 합병증을 예방하고 있죠. 수술 후에도 정기적인 경과 관찰과 관리로 혹시 모를 문제를 조기에 발견해 대처해요.'
    },
    { 
      question: '한국의 성형수술 비용은 어느 정도인가요?',
      answer: '수술 종류와 난이도에 따라 비용 차이가 있지만, 한국 성형 비용은 전반적으로 합리적이라는 평가예요. 국공립 대형병원보다는 개인 전문병원에서 받는 경우가 많아 평균 비용이 다양해요. 정확한 비용은 상담 시 개인 상태와 원하는 시술 범위에 따라 견적을 받아보는 것이 좋아요.'
    },
    { 
      question: '한국에서 어떤 성형수술이 가장 인기 있나요?',
      answer: '쌍꺼풀 수술, 코 성형, 안면윤곽술 등 얼굴 중심의 수술이 특히 인기 있어요. 또한, 피부 탄력을 위한 리프팅이나 보톡스 같은 시술도 많이 받아요. 개인마다 원하는 개선 부위가 달라 전문의와 상담해서 본인에게 맞는 수술을 선택해요.'
    },
    { 
      question: '성형수술 후 회복 기간은 얼마나 걸리나요?',
      answer: '수술 종류에 따라 다르지만 대개 12주 정도면 일상생활이 가능해져요. 부기나 멍은 보통 23주에 걸쳐 호전되고, 완전한 회복은 3~6개월쯤 걸려요. 물론 개인 차이가 있으니 담당 의사의 지시에 따라 회복 일정을 계획하는 게 좋아요.'
    },
    { 
      question: '성형수술 결과가 마음에 안 들면 어떻게 해야 하나요?',
      answer: '우선 수술 후 충분한 회복 기간을 가진 후에 결과를 판단해야 해요. 그래도 만족스럽지 않다면 담당 의사와 솔직하게 상의해보세요. 필요에 따라 보정 시술이나 재수술을 고려할 수 있고, 이때는 전문의의 조언을 따르는 게 중요해요.'
    },
  ],
  jp: [
    { 
      question: '韓国で整形手術が有名な理由は何ですか？',
      answer: '韓国の整形手術は、最新技術と熟練した専門医のおかげで自然な結果をもたらすことで知られています。手術前の詳細なカウンセリングと個人に合わせた計画により、満足度が高くなっています。K-ビューティートレンドと韓流の影響で、世界中の患者から信頼され、訪れています。'
    },
    { 
      question: '韓国の整形外科には外国人患者も多く訪れますか？',
      answer: 'はい、韓国の整形外科は外国人患者に人気があります。英語、中国語、日本語などの多様な言語サービスと医療通訳者がサポートしているので安心してください。海外患者向けの専門コーディネーターもいるため、相談や手術を便利に受けることができます。'
    },
    { 
      question: '整形手術の前後にどのような準備と注意が必要ですか？',
      answer: '手術前には健康状態をチェックし、医師と期待する結果について十分に相談する必要があります。手術後は禁煙、禁酒とともに処方された薬をきちんと服用し、安静にする必要があります。また、手術部位を清潔に管理し、無理な運動や活動は避けることをお勧めします。'
    },
    { 
      question: '韓国で整形手術を受ける際、麻酔は安全ですか？',
      answer: '韓国の整形外科には専門の麻酔科医がいるため、麻酔過程が安全に管理されています。手術前の麻酔関連のカウンセリングで健康状態をチェックするので安心してください。万が一の緊急事態にも備えて必要な機器や手順が準備されているため、安全に進められます。'
    },
    { 
      question: '韓国の整形外科医は最新トレンドをよく反映していますか？',
      answer: 'はい、韓国の医師たちはK-ビューティーをはじめとする最新の美容トレンドを積極的に反映しています。世界中からの多様な美容の好みを研究しているため、様々なスタイルを理解しています。医師と十分に相談すれば、希望するイメージに合わせて調整することができます。'
    },
    { 
      question: '整形手術の副作用や合併症はどのように予防されますか？',
      answer: '手術前の精密検査と丁寧な診断により、副作用の可能性を最小限に抑えています。手術中の無菌管理と熟練した医師の技術で合併症を予防しています。手術後も定期的な経過観察と管理で、万が一の問題を早期に発見して対処します。'
    },
    { 
      question: '韓国の整形手術費用はどのくらいですか？',
      answer: '手術の種類と難易度によって費用に差がありますが、韓国の整形費用は全般的に合理的だと評価されています。国公立の大型病院よりも個人の専門病院で受ける場合が多いため、平均費用は多様です。正確な費用は、相談時に個人の状態と希望する施術範囲に応じて見積もりを受けることをお勧めします。'
    },
    { 
      question: '韓国ではどのような整形手術が最も人気がありますか？',
      answer: '二重まぶた手術、鼻整形、輪郭整形など顔を中心とした手術が特に人気があります。また、肌の弾力性のためのリフティングやボトックスなどの施術も多く受けられています。個人によって改善したい部位が異なるため、専門医と相談して自分に合った手術を選ぶことをお勧めします。'
    },
    { 
      question: '整形手術後の回復期間はどのくらいかかりますか？',
      answer: '手術の種類によって異なりますが、通常1-2週間程度で日常生活が可能になります。腫れやあざは通常2-3週間かけて改善し、完全な回復は3-6ヶ月ほどかかります。もちろん個人差がありますので、担当医の指示に従って回復スケジュールを計画することをお勧めします。'
    },
    { 
      question: '整形手術の結果に満足しない場合、どうすればよいですか？',
      answer: 'まず、手術後に十分な回復期間を経てから結果を判断する必要があります。それでも満足できない場合は、担当医と率直に相談してみてください。必要に応じて修正施術や再手術を検討することができ、その際は専門医のアドバイスに従うことが重要です。'
    },
  ],
  ch: [
    { 
      question: '韩国整形手术为什么有名？',
      answer: '韩国整形手术因最新技术和熟练专业医生而闻名，能带来自然的效果。手术前的详细咨询和个人定制计划使满意度很高。受K-美容潮流和韩流影响，韩国整形手术在全球患者中备受信赖。'
    },
    { 
      question: '韩国整形医院是否有很多外国患者光顾？',
      answer: '是的，韩国整形医院在外国患者中很受欢迎。有英语、中文、日语等多种语言服务和医疗翻译提供支持，请放心。还有专门为海外患者服务的专业协调员，让咨询和手术更加便捷。'
    },
    { 
      question: '整形手术前后应该做哪些准备和注意事项？',
      answer: '手术前需要检查健康状况，并与医生充分讨论预期效果。手术后需要禁烟、禁酒，按时服用处方药，并保持休息。此外，保持手术部位的清洁，避免剧烈运动或活动也很重要。'
    },
    { 
      question: '在韩国做整形手术时麻醉安全吗？',
      answer: '韩国整形医院有专业麻醉科医生，麻醉过程得到安全管理。手术前会通过麻醉相关咨询检查健康状况，请放心。为应对可能的紧急情况，必要的设备和程序也已准备就绪，确保安全进行。'
    },
    { 
      question: '韩国整形医生是否能很好地反映最新潮流？',
      answer: '是的，韩国医生积极反映包括K-美容在内的最新美容潮流。他们研究来自世界各地的多样化美容偏好，了解各种风格。与医生充分讨论后，可以按照您想要的形象进行调整。'
    },
    { 
      question: '如何预防整形手术的副作用或并发症？',
      answer: '通过手术前的精密检查和细致诊断，尽量减少副作用的可能性。手术中的无菌管理和熟练医生的技术预防并发症。手术后也通过定期的观察和管理，早期发现并处理可能出现的问题。'
    },
    { 
      question: '韩国整形手术费用大约是多少？',
      answer: '根据手术类型和难度，费用有所不同，但韩国整形费用普遍被认为是合理的。由于很多人选择在私人专科医院而非公立大型医院进行手术，平均费用各异。建议在咨询时根据个人情况和所需手术范围获取准确报价。'
    },
    { 
      question: '韩国哪些整形手术最受欢迎？',
      answer: '双眼皮手术、鼻整形、颧骨整形等面部手术特别受欢迎。此外，提升皮肤弹性的拉皮或肉毒素等治疗也很常见。每个人想要改善的部位不同，建议咨询专科医生，选择适合自己的手术。'
    },
    { 
      question: '整形手术后恢复期需要多长时间？',
      answer: '根据手术类型不同，通常1-2周后可以恢复日常生活。肿胀和瘀伤通常在2-3周内改善，完全恢复需要3-6个月左右。当然个体差异存在，建议按照主治医生的指示计划恢复日程。'
    },
    { 
      question: '如果对整形手术结果不满意，应该怎么办？',
      answer: '首先，手术后需要有足够的恢复期再判断结果。如果仍不满意，请坦诚地与主治医生商量。必要时可以考虑修正手术或再次手术，这时遵循专业医生的建议很重要。'
    },
  ],
  ru: [
    {
      "question": "Почему пластическая хирургия так популярна в Корее?",
      "answer": "Корейская пластическая хирургия известна своими естественными результатами благодаря передовым технологиям и высококвалифицированным специалистам. Подробные предоперационные консультации и индивидуальное планирование приводят к высокому уровню удовлетворенности. Влияние трендов K-beauty и Корейской волны сделало ее надежной для пациентов по всему миру."
    },
    {
      "question": "Много ли иностранных пациентов посещают корейские клиники пластической хирургии?",
      "answer": "Да, корейские клиники пластической хирургии популярны среди иностранных пациентов. Для вашего удобства доступны различные языковые услуги, включая английский, китайский и японский, а также медицинские переводчики. Специализированные координаторы для международных пациентов делают консультации и операции удобными."
    },
    {
      "question": "Что мне нужно подготовить и о чем быть осторожным до и после пластической операции?",
      "answer": "Перед операцией проверьте свое состояние здоровья и тщательно обсудите ожидаемые результаты с врачом. После операции избегайте курения и употребления алкоголя, принимайте прописанные лекарства и много отдыхайте. Также важно поддерживать чистоту операционной области и избегать напряженных упражнений или активностей."
    },
    {
      "question": "Безопасна ли анестезия при проведении пластической операции в Корее?",
      "answer": "В корейских клиниках пластической хирургии работают профессиональные анестезиологи, которые безопасно управляют процессом анестезии. Предоперационные консультации по анестезии проверяют ваше состояние здоровья, так что вы можете чувствовать себя спокойно. Необходимое оборудование и процедуры подготовлены для любых потенциальных чрезвычайных ситуаций, обеспечивая безопасные процедуры."
    },
    {
      "question": "Хорошо ли корейские пластические хирурги отражают последние тенденции?",
      "answer": "Да, корейские врачи активно внедряют последние тенденции красоты, включая K-beauty. Они изучают разнообразные предпочтения в красоте со всего мира, понимая различные стили. Тщательно обсудив с врачом, вы сможете скорректировать подход, чтобы он соответствовал желаемому образу."
    },
    {
      "question": "Как предотвращаются побочные эффекты или осложнения пластической хирургии?",
      "answer": "Тщательные предоперационные обследования и детальные диагнозы минимизируют возможность побочных эффектов. Во время операции стерильное управление и квалифицированные методы предотвращают осложнения. Регулярный послеоперационный мониторинг и уход помогают выявлять и устранять любые потенциальные проблемы на ранней стадии."
    },
    {
      "question": "Сколько стоит пластическая операция в Корее?",
      "answer": "Стоимость варьируется в зависимости от типа и сложности операции, но в целом затраты на корейскую пластическую хирургию считаются разумными. Поскольку многие процедуры проводятся в частных специализированных клиниках, а не в государственных больницах, средние затраты могут значительно отличаться. Для получения точной цены лучше всего получить смету во время консультации, исходя из вашего индивидуального состояния и желаемого объема процедур."
    },
    {
      "question": "Какие пластические операции наиболее популярны в Корее?",
      "answer": "Особенно популярны операции, ориентированные на лицо, такие как операция по созданию двойного века, ринопластика и контурная пластика лица. Процедуры, такие как лифтинг для эластичности кожи и инъекции ботокса, также распространены. Поскольку каждый хочет улучшить разные области, рекомендуется проконсультироваться со специалистом, чтобы выбрать операцию, которая подходит именно вам."
    },
    {
      "question": "Сколько длится период восстановления после пластической операции?",
      "answer": "Время восстановления варьируется в зависимости от процедуры, но обычно повседневная деятельность становится возможной через 1-2 недели. Отек и синяки обычно проходят через 2-3 недели, а полное восстановление занимает около 3-6 месяцев. Существуют индивидуальные различия, поэтому лучше всего планировать график восстановления в соответствии с инструкциями врача."
    },
    {
      "question": "Что делать, если я не удовлетворен результатами моей пластической операции?",
      "answer": "Во-первых, дайте достаточно времени для восстановления, прежде чем судить о результатах. Если вы все еще не удовлетворены, откровенно обсудите это с врачом. Могут быть рассмотрены корректирующие процедуры или повторные операции, если это необходимо, и в этих случаях важно следовать советам вашего специалиста."
    }
  ]
}